

import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from 'swiper/modules';
import 'swiper/css';
import portfolio_img_1 from '../../assets/img/wd.webp';
import portfolio_img_4 from '../../assets/img/dm.jpg';
import portfolio_img_2 from '../../assets/img/portfolio_2.jpg';
// import portfolio_img_3 from '../../assets/img/portfolio_3.jpg';
import portfolio_img_3 from '../../assets/img/smm1.webp';
import portfolio_img_5 from '../../assets/img/sd.webp';
// import portfolio_img_6 from '../../assets/img/gd.webp';
import portfolio_img_6 from '../../assets/img/gd1.jpg';
import { Link } from 'react-router-dom';
import { useEffect, useRef } from "react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import SplitText from "gsap/SplitText"; // Make sure you have access to SplitText plugin
gsap.registerPlugin(ScrollTrigger, SplitText);


const portfolio_slider = [
  {
    img: portfolio_img_5,
    // img:"https://images.unsplash.com/photo-1519408469771-2586093c3f14?q=80&w=702&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    title: `Web Development`,
    category: `Services / Web Development`,
    path: `/portfolio-website`
  },
  {
    img: portfolio_img_6,
    title: `Graphics/Video`,
    category: `Services / Graphics`,
    path: `/portfolio-graphics`
  },
  {
    img: portfolio_img_3,
    title: `SMM & SMO`,
    category: `Services / SMM & SMO`,
    path: `/portfolio-smm-smo`
  },
  {
    img: portfolio_img_1,
    title: `Softwares`,
    category: `Services / Application Development`,
    path: `/portfolio-software`
  },
  {
    img: portfolio_img_4,
    title: `Digital Marketing`,
    category: `Services / Digital Marketing`,
    path: `/portfolio-digital-marketing`
  },
]


const Portfolio = () => {

  const containerRef = useRef();
  const handleFooterLink = () => {
    setTimeout(() => {
      window.scrollTo({ top: 0, behavior: "auto" });
    });
  };
  useEffect(() => {
    let ctx = gsap.context(() => {
      let splitTitleLines = gsap.utils.toArray(".anim_heading_title");

      splitTitleLines.forEach((splitTextLine) => {
        const tl = gsap.timeline({
          scrollTrigger: {
            trigger: splitTextLine,
            start: "top 90%",
            end: "bottom 60%",
            scrub: false,
            markers: false,
            toggleActions: "play none none none",
          },
        });

        const itemSplitted = new SplitText(splitTextLine, {
          type: "words, lines",
        });

        gsap.set(splitTextLine, { perspective: 400 });

        // optional: resplit if necessary
        itemSplitted.split({ type: "lines" });

        tl.from(itemSplitted.lines, {
          duration: 1,
          delay: 0.3,
          opacity: 0,
          rotationX: -80,
          force3D: true,
          transformOrigin: "top center -50",
          stagger: 0.1,
        });
      });
    }, containerRef);

    return () => ctx.revert();
  }, []);
  useEffect(() => {
    let ctx = gsap.context(() => {
      let splitTitleLines = gsap.utils.toArray(".anim_div_ShowDowns");


      splitTitleLines.forEach((showsDown) => {
        gsap.set(showsDown, {
          opacity: 0,
          y: +100,
        });

        gsap.to(showsDown, {
          scrollTrigger: {
            trigger: showsDown,
            start: "top 90%",
            end: "bottom 60%",
            markers: false,
          },
          opacity: 1,
          y: -0,
          ease: "power2.out",
          duration: 2,
          stagger: 1,
        });
      });
    }, containerRef);

    return () => ctx.revert();
  }, []);

  return (
    <>
      <div ref={containerRef}>
        <div className="cs_horizontal_scroll_wrap">
          <div className="cs_height_145 cs_height_lg_60"></div>
          <div className="container">
            <div className="cs_section_heading cs_style_1 cs_type_2">
              <div className="cs_section_heading_text">
                <div className="cs_section_subtitle anim_div_ShowZoom">
                  Portfolio
                </div>
                <h2 className="cs_section_title anim_heading_title">
                  Recent Projects We've Successfully Delivered
                </h2>
              </div>
            </div>
            {/* <div className="cs_height_100 cs_height_lg_60"></div> */}
          </div>
          {/* <Swiper
          loop={true}
          speed={1000}
          slidesPerView="auto" 
          pagination={{
            el: ".cs_pagination",
            clickable: true,
          }}
          className="cs_horizontal_scrolls anim_div_ShowDowns"> */}
          <Swiper
            modules={[Autoplay]}
            loop={true}
            speed={1000}
            slidesPerView="auto"
            autoplay={{
              delay: 2000,
              disableOnInteraction: false,
            }}
            pagination={{
              el: ".cs_pagination",
              clickable: true,
            }}
            className="cs_horizontal_scrolls anim_div_ShowDowns">
            {portfolio_slider.map((item, i) =>
              <SwiperSlide key={i} className="swiper-slide">
                <div className="cs_horizontal_scroll">
                  <Link to={`${item.path}`} className="cs_portfolio cs_style_1" onClick={handleFooterLink}>
                    <div className="cs_portfolio_img">
                      <img src={item.img} alt="Thumb" />
                    </div>
                    <div className="cs_portfolio_overlay"></div>
                    <div className="cs_portfolio_info">
                      <h2 className="cs_portfolio_title">
                        {item.title}
                      </h2>
                      <div className="cs_portfolio_subtitle" style={{ color: "lightgray" }}>
                        {item.category}
                      </div>
                    </div>
                  </Link>
                </div>
              </SwiperSlide>
            )}

          </Swiper>
        </div>
        <div className="cs_height_145 cs_height_lg_60"></div>
      </div>
    </>
  );
};

export default Portfolio;